// extracted by mini-css-extract-plugin
export default {"closeButton":"closeButton-WD7yPUEUkXCXGeGJ_tMF","picto":"picto-mNlInjJzFCxTLp4gBP2A","closeModal":"closeModal-__QYjAC_tn61llBkLxOt"};